export default __webpack_public_path__ + "static/media/4.af646818.jpg";